import { ErrorType } from 'types/error';

const errors = {
  industry: {
    message: 'Your industry is not covered by us.',
    question: 'Please select an industry',
    errorType: 'business',
  },
  occupationCategory: {
    message: 'Your occupation is not covered by us.',
    question: 'Please select an occupation',
    errorType: 'business',
  },
  occupation: {
    message: 'Your specific occupation is not covered by us.',
    question: 'Please select an exact occupation',
    errorType: 'business',
  },
  employeeCount: {
    message: 'Your disclosed number of employees is outside our limit.',
    question: 'How many employees do you currently have?',
    errorType: 'business',
  },
  turnover: {
    message: 'Your disclosed turnover is outside our limit.',
    question: "What's your estimated turnover for the next 12 months?",
    errorType: 'business',
  },
  turnoverPropertyOwner: {
    message: 'Your disclosed rental income is outside our limit.',
    question: "What's your estimated rental income for the next 12 months?",
    errorType: 'business',
  },
  propertyValue: {
    message: 'Your disclosed property value is outside our limit.',
    question: "What's the value of your property?",
    errorType: 'business',
  },
  useOfContractors: {
    message: 'Use of contractors value greater than product limit.',
    question: 'How much will you pay to contractors over the next 12 months?',
    errorType: 'business',
  },
  noOfclaims: {
    message: 'The number of claims you have declared exceeds our limits via this website',
    question: 'In the past 5 years, how many claims has your business made?',
    errorType: 'business',
  },
  historyQuestions: {
    message: 'You answered Yes on one or more of the Customer history questions',
    question: 'In the past 5 years, how many claims has your business made?',
    errorType: 'business',
  },
  malformedMulesoftError: {
    message: 'Mulesoft API returned malformed server error response',
    question: '',
    errorType: 'mulesoft',
  },
  policyNumberNotFound: {
    message: "Can't bind without Policy Number",
    question: '',
    errorType: 'technical',
  },
  quoteNumberNotFound: {
    message: 'Could not retrieve Quote Number',
    question: '',
    errorType: 'technical',
  },
  accessTokenNotFound: {
    message: 'Could not retrieve access token',
    question: '',
    errorType: 'technical',
  },
  transientTokenNotFound: {
    message: 'Could not retrieve transient token',
    question: '',
    errorType: 'technical',
  },
  buildingEPS: {
    message: "You entered 'Over 20%' for EPS, and as a result we are unable to offer you a quote",
    question: 'Does your building have any internal or external Expanded Polysterene (EPS)',
    errorType: 'business',
  },
  missingLiabilityRisk: {
    message: 'Liability risk is missing from response',
    question: '',
    errorType: 'technical',
  },
  missingInceptionDate: {
    message: 'Inception date is missing from response',
    question: '',
    errorType: 'technical',
  },
  invalidQueryParams: {
    message: 'Invalid query params',
    question: '',
    errorType: 'technical',
  },
  genericDecline: {
    message: 'We are unable to offer a quote at this time.',
    question: '',
    errorType: 'business',
  },
};

export default errors as { [key in keyof typeof errors]: ErrorType };
